import { PaymentType, ValueWithUnit } from '@repo/shared/components'
import { Col, DeltaBadge, Row, Typography } from '@repo/ui/components'
import { type CSSVariableColor } from '@repo/ui/types/colors'

export interface HistoryChangesProps {
  changes: Array<{
    label: string
    value: number
    percent: number | string
  }>
}

export const HistoryChanges = ({ changes }: HistoryChangesProps) => {
  const getChangeColors = (
    percent: number,
  ): {
    bg: CSSVariableColor
    text: CSSVariableColor
    icon: CSSVariableColor
  } => {
    if (percent > 0) {
      return {
        bg: 'bg-positive-surface',
        text: 'text-positive-surface-100',
        icon: 'fill-positive-surface-100',
      }
    }
    if (percent < 0) {
      return {
        bg: 'bg-negative-surface',
        text: 'text-negative-surface-80',
        icon: 'fill-negative-surface-80',
      }
    }
    return {
      bg: 'bg-neutral-surface',
      text: 'text-neutral-main',
      icon: 'fill-neutral-main',
    }
  }

  return (
    <Row className='gap-lg justify-center w-full mt-md'>
      <Col className='gap-md'>
        {changes.map((c, i) => (
          <Typography key={i} size='2xs' color='text-neutral-surface-80'>
            {c.label}
          </Typography>
        ))}
      </Col>
      <Col className='gap-md'>
        {changes.map((c, i) => {
          const colors = getChangeColors(+c.percent)
          return (
            <Row
              key={i}
              className='gap-xs whitespace-nowrap justify-end min-h-lg'
            >
              <ValueWithUnit
                value={Math.abs(c.value)}
                valueSize='2xs'
                unitSize='2xs'
                unit='TMN'
                valueColor={colors.text}
                unitColor={colors.text}
                decimalPlaces={0}
                scale={10}
              />
              <DeltaBadge value={+(c.percent ?? 0)} variant='ghost' size='sm' />
            </Row>
          )
        })}
      </Col>
    </Row>
  )
}
